module.exports = __webpack_public_path__ + "static/media/adminLogo.cb8f8e27.svg";